module.exports = __webpack_public_path__ + "static/media/All done.2e7bda7d.gif";